export const PRIORITY = {
  MINOR: 'Minor',
  MEDIUM: 'Medium',
  CRITICAL: 'Critical',
} as const;

export type PriorityValue = (typeof PRIORITY)[keyof typeof PRIORITY];
